import React from "react";
import {StepSelectValidationOptions} from "./StepSelectValidationOptions/StepSelectValidationOptions";
import {StepProducts} from "./stepProducts/StepProducts";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import PasswordStep from "./passwordStep/PasswordStep";
import {useAppContext} from "../context/AppContext";
import ContactabilityStep from "./contactabilityStep/ContactabilityStep";
import RutStep from "./rutStep/RutStep";
import setConfig from "cldffecop-tagging-utils";
import PlanContracts from "./planContracts/PlanContracts";

export const StepsClient = () => {
    const {state: context, changeItem} = useAppContext();
    const changeContextClientStep = (step) => {
      
        changeItem({clientStep: step});
    };

    setConfig({
        name: "Wealth-Management",
        brand: "Scotiabank",
        variant: "publico", // privado o publico
        category: "steps-clients",
    });

    return (
        <div>
            {context.clientStep === "stepRut" && <RutStep/>}
            {context.clientStep === "stepContactability" && <ContactabilityStep/>}
            {context.clientStep === "accountCreate" && <PasswordStep/>}
            <Grid className="Steps">
                <Row justifyContent="center">
                    <Column lg={8}>
                        {context.clientStep === "stepSelectValidationOptions" && (
                            <StepSelectValidationOptions/>
                        )}
                        {context.clientStep === "stepProducts" && (
                            <StepProducts changeContextClientStep={changeContextClientStep}/>
                        )}
                        {context.clientStep === "planContracts" && (
                            <PlanContracts
                                changeContextClientStep={changeContextClientStep}
                            />
                        )}
                    </Column>
                </Row>
            </Grid>
        </div>
    );
};
